import React, { useEffect, useRef, useState } from 'react';
// import styles from './HeroSection.module.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Container, Row, Col } from 'react-bootstrap';
import 'swiper/css';
import 'swiper/css/pagination';
import Typed from 'typed.js';
import { Shimmer } from 'react-shimmer';

// Images
import phoneFrame from '../assets/images/mobile-screen.svg';
import bannerBg from '../assets/images/bg-img.png';

//Import SVG Icons
import {BannerSliderSVG} from '../components/SvgIcons';

const HeroSection = ({ webContent, isLoading, isError, error }) => {
  const typedRef = useRef(null);
  const sliderImages = webContent?.dataset?.data['heading-section']?.json_data?.mobile_images || [];
  const hoverImage = webContent?.dataset?.data['heading-section']?.json_data?.mobile_hover_image;
  const hoverImageUrl = webContent?.dataset?.data['heading-section']?.json_data?.hover_image_url || '';
  const title = webContent?.dataset?.data['heading-section']?.json_data?.title || '';
  const headingText = webContent?.dataset?.data['heading-section']?.json_data?.heading_text || '';
  const smallDescription = webContent?.dataset?.data['heading-section']?.json_data?.small_description || '';
  const buttons = webContent?.dataset?.data['heading-section']?.json_data?.buttons || [];

  // State to track which images are loaded
  const [loadedImages, setLoadedImages] = useState({});

  useEffect(() => {
    if (!title) return;

    const typed = new Typed(typedRef.current, {
      strings: [title],
      typeSpeed: 100,
      startDelay: 0,
      backSpeed: 60,
      backDelay: 2000,
      loop: true,
    });

    return () => {
      typed.destroy();
    };
  }, [title]);

  // Function to handle image load
  const handleImageLoad = (index) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  };

  if (isLoading) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}>
        <img
          src="https://stg-admin.gkcloud.in/storage/settings/backend_favicon_1739509041.png"
          alt="Loading..."
          style={{
            width: '100px',
            height: 'auto',
            animation: 'pulse 1.5s infinite'
          }}
        />
        <style>
          {`
            @keyframes pulse {
              0% { transform: scale(1); }
              50% { transform: scale(1.1); }
              100% { transform: scale(1); }
            }
          `}
        </style>
      </div>
    );
  }

  if (isError) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}>
        <p>Error loading content: {error.message}</p>
      </div>
    );
  }

  return (
    <div
      className="heroContainer" >
          <div className="svg-position svg-img bannerSVG">
       <BannerSliderSVG/>
<div className="svg-content w-100">
      {/* Floating Dots */}
      <div className="floating-dots">
        {[...Array(10)].map((_, i) => (
          <div className="dot" key={i}></div>
        ))}
      </div>

      <Container>
        <Row className="align-items-center">
          {/* Left Content - 6 Columns */}
          <Col lg={6}>
            <div className="leftContent">
              <div className="animated-textt">
                <span ref={typedRef} className="typed"></span>
              </div>
              <h1 className="heading" dangerouslySetInnerHTML={{ __html: headingText }} />
              <p className="subtext">{smallDescription}</p>
              <div className="app-buttons">
                {buttons && buttons.length > 0 ? (
                  buttons.map((button, index) => (
                    <a href={button.url} key={index} title={button.text} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 10px' }}>
                      <img src={button.image} alt={button.text} />
                      <span style={{ marginTop: '8px', color: 'white', fontSize: '14px', fontWeight: '500' }}>{button.text}</span>
                    </a>
                  ))
                ) : (
                  <>
                    <a href="#" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 10px' }}>
                      <img src="https://stg-admin.gkcloud.in/storage/web_sections/2025/04/file_1744283986_4afb87ec-1c68-4e49-abac-03618797627f.png" alt="App Store" />
                      <span style={{ marginTop: '8px', color: 'white', fontSize: '14px', fontWeight: '500' }}>App Store</span>
                    </a>
                    <a href="#" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 10px' }}>
                      <img src="https://stg-admin.gkcloud.in/storage/web_sections/2025/04/file_1744283986_79cb265e-60c7-4cb9-9757-7744b5bf14c8.png" alt="Google Play" />
                      <span style={{ marginTop: '8px', color: 'white', fontSize: '14px', fontWeight: '500' }}>Google Play</span>
                    </a>
                  </>
                )}
              </div>
            </div>
          </Col>

          {/* Right Content - 6 Columns */}
          <Col lg={6}>
            <div className="rightContent">
              <div className="phoneSlider">
                <div className="phoneWrapper">
                  <img src={phoneFrame} className="phoneFrame" alt="Phone Frame" />
                  <div className="phoneScreen">
                    {isLoading ? (
                      <Shimmer width={400} height={800} />
                    ) : sliderImages.length > 0 ? (
                      <Swiper
                        modules={[Autoplay, Pagination]}
                        pagination={{
                          clickable: true,
                          el: '.swiper-pagination',
                          bulletClass: 'swiper-pagination-bullet',
                          bulletActiveClass: 'swiper-pagination-bullet-active'
                        }}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        loop={true}
                        slidesPerView={1}
                        className="phoneSwiper"
                        style={{
                          '--swiper-pagination-color': '#007bff',
                          '--swiper-pagination-bullet-size': '8px',
                          '--swiper-pagination-bullet-horizontal-gap': '6px'
                        }}
                      >
                        {sliderImages.map((image, index) => (
                          <SwiperSlide key={index}>
                            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                              {!loadedImages[index] && (
                                <Shimmer
                                  width="100%"
                                  height="100%"
                                  style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    zIndex: 1,
                                    objectFit: 'cover'
                                  }}
                                />
                              )}
                              <img
                                src={image}
                                alt={`Slide ${index + 1}`}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                  display: loadedImages[index] ? 'block' : 'block',
                                  visibility: loadedImages[index] ? 'visible' : 'hidden',
                                  position: 'absolute',
                                  top: 0,
                                  left: 0
                                }}
                                onLoad={() => handleImageLoad(index)}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  setLoadedImages((prev) => ({ ...prev, [index]: true })); // Mark as loaded to remove placeholder
                                }}
                              />
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    ) : null}
                  </div>
                </div>
                <div className="swiper-pagination" style={{
                  position: 'absolute',
                  bottom: '-30px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 10
                }}></div>
              </div>

              {hoverImage && (
                <div className="clientReview">
                  <a href={hoverImageUrl} target="_blank" rel="noopener noreferrer">
                    <img src={hoverImage} alt="Client Review" className="animatedImage" />
                  </a>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    </div>
    </div>
  );
};

export default HeroSection;
